import { render, staticRenderFns } from "./process-dpa-radios.vue?vue&type=template&id=2145928f"
import script from "./process-dpa-radios.vue?vue&type=script&lang=js"
export * from "./process-dpa-radios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports